import { render, staticRenderFns } from "./_ContactInfoEditDialog.vue?vue&type=template&id=39bb8ddd"
import script from "./_ContactInfoEditDialog.vue?vue&type=script&lang=js"
export * from "./_ContactInfoEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports